/**
 * Cognito SSO configuration
 * Following the constitution's auth pattern from NEW_SITE_CONSTITUTION_GUIDE.md
 */
import { configureCognito } from '@codespeak11/cognito-passwordless';

configureCognito({
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_PCfRCmOyx',
  clientId: import.meta.env.VITE_SPA_CLIENT_ID || '79ujfgkb87jugfa8hi7hshphra',
  sso: {
    role: 'client',
    portalUrl: import.meta.env.VITE_SSO_PORTAL_URL || 'https://auth.braindance.net',
    cognitoDomain:
      import.meta.env.VITE_SSO_COGNITO_DOMAIN ||
      'https://braindance-auth-prod.auth.us-east-1.amazoncognito.com',
    callbackUrl: `${window.location.origin}/auth/callback`,
    signOutUrl: window.location.origin,
    scopes: ['openid', 'email', 'profile'],
  },
});
